<template>
<div class="InstitutionManagementContainer">
  <div class="mainContent" :style="styleObject">
    <div class="contentShowArea">
      <div class="contentArea">
        <div class="treeAside">
          <div class="treeTop">
            <span class="treeTopTitle">组织</span>
            <el-button v-show="!treeHandler" type="text" @click="treeHandler = !treeHandler" style="color:#2d8cf0;margin-left:170px;">维护</el-button>
            <!-- <el-button title="添加根组织" v-show="treeHandler&&rolePermit('org:add') /*&& isPermit('org:add') && isTenant()*/" type="text" size="small" icon="el-icon-plus" @click.stop="clickAddOrganize" style="color:#2d8cf0;"></el-button> -->
            <el-button class="complete" v-show="treeHandler" type="text" @click="treeHandler = !treeHandler" style="color:#ff9900;margin-left:170px;">完成</el-button>
          </div>
          <div class="treeBox">
            <!-- <el-tree v-if="1" class="tree" ref="tree" :indent=6 :data="treeData" how-checkbox node-key="value" default-expand-all highlight-current :expand-on-click-node="false" @node-click="handleNodeSelect">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <el-tooltip :content="node.label" placement="right-end" effect="light" :visible-arrow="true">
                  <span class="treeLabel" :style="{width : treeHandler ? '130px' : '190px'}">{{ showLabel(node.label) }}</span>
                </el-tooltip>
                node.label != '终端用户' 终端用户不让修改
                <span v-show="treeHandler && (node.label != '终端用户')" class="treeBtn">
                  <el-button v-if="true || rolePermit('org:add')" type="text" size="small" icon="el-icon-plus" @click.stop="clickAddOrganize(data)" style="color:#2d8cf0;"></el-button>
                  <el-button v-if="true || rolePermit('org:edit')" type="text" size="small" icon="el-icon-edit" @click.stop="clickEditOrganize(data)" style="color:#2d8cf0;"></el-button>
                  <el-button v-if="true || rolePermit('org:del')" type="text" size="small" icon="el-icon-close" @click.stop="clickRemoveOrganize(node, data)" style="color:#ed4014;"></el-button>
                </span>
              </span>
            </el-tree> -->
            <el-tree
              lazy
              :load="orgLoadData"
              :props="props"
              class="tree"
              ref="orgtree"
              :indent="5"
              node-key="value"
              highlight-current
              :expand-on-click-node="false"
              @node-click="handleNodeSelect">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <el-tooltip :content="node.label" placement="right-end" effect="light" :visible-arrow="true">
                  <span class="treeLabel" :style="{width : treeHandler ? '130px' : '190px'}">{{ showLabel(node.label) }}</span>
                </el-tooltip>
                <!-- node.label != '终端用户' 终端用户不让修改 -->
                <span v-show="treeHandler && (node.label != '终端用户')" class="treeBtn">
                  <el-button v-if="true || rolePermit('org:add')" type="text" size="small" icon="el-icon-plus" @click.stop="clickAddOrganize(data)" style="color:#2d8cf0;"></el-button>
                  <el-button v-if="true || rolePermit('org:edit')" type="text" size="small" icon="el-icon-edit" @click.stop="clickEditOrganize(data)" style="color:#2d8cf0;"></el-button>
                  <el-button v-if="true || rolePermit('org:del')" type="text" size="small" icon="el-icon-close" @click.stop="clickRemoveOrganize(node, data)" style="color:#ed4014;"></el-button>
                </span>
              </span>
            </el-tree>
          </div>
        </div>
        <div class="management">
          <div class="userManagement">
            <div class="title">用户列表</div>
            <div class="umHandler">
              <div class="umHandlerLeft">
                <el-input placeholder="请输入昵称" v-model="queryForm.nickName" style="width:200px;"></el-input>
                <el-input placeholder="请输入邮箱地址" v-model="queryForm.email" style="width:200px;"></el-input>
                <el-input placeholder="请输入联系方式" v-model="queryForm.tel" style="width:200px;"></el-input>
                <el-select v-model="queryFormRoles" multiple collapse-tags @visible-change="queryAllRoles" placeholder="请选择角色">
                  <el-option class="treeCommon" v-for="item in roles" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
                <el-select v-model="queryForm.isEnabled" clearable placeholder="是否启用">
                  <el-option label="启用" value="1"></el-option>
                  <el-option label="禁用" value="0"></el-option>
                </el-select>
                <!-- <el-button slot="append" size="small" icon="el-icon-search" @click="searchAlco"></el-button> -->
                <button v-if="rolePermit('org:user:query')" class="primaryBtn" @click="searchAlco">搜索</button>
                <el-button :style="{background:treeFlag==true?'#ccc':'#2177E6',cursor:treeFlag==true?'not-allowed':'pointer'}" v-if="rolePermit('org:user:add')" class="primaryBtn" @click="showAddForm">添加用户</el-button>
              </div>
              <!-- <el-button v-if="true || isPermit('user:add')" class="add" type="primary" icon="el-icon-plus" @click="showAddForm()">添加用户</el-button> -->
              <!-- <el-button class="refresh" icon="el-icon-refresh" @click="searchAlco();"></el-button> -->
            </div>
            <div class="umTableBox">
              <div class="tableBox">
                <border-table class="dataTable" :loading="rolesLoading" :tableData="actionQueryData" :pageSizes="[10, 20, 50]" :pages="pagination" @currentChange="handleCurrentChange" @sizeChange="handleSizeChange">
                  <!-- <el-table v-if="total>0" class="dataTable" :max-height="tableMaxHeight" :data="actionQueryData" stripe style="width: 100%;"> -->
                  <el-table-column prop="id" label="ID" width="70" sortable></el-table-column>
                  <el-table-column prop="nickName" label="昵称" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="email" label="邮箱地址" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="tel" label="联系方式" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="isEnabled" label="是否启用">
                    <template slot-scope="scope">
                      <span v-if="scope.row.isEnabled" style="color:#28C6A2">启用</span>
                      <span v-else style="color:#DD3071">禁用</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="loginName" label="登录名" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.loginName == null ? "-" : scope.row.loginName}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="isLock" label="账户状态">
                    <template slot-scope="scope">
                      <span v-if="scope.row.isLock == null" style="color:#DD3071">-</span>
                      <span v-else>
                        <span v-if="scope.row.isLock" style="color:#DD3071">锁定</span>
                        <span v-else style="color:#28C6A2">正常</span>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="lockExpiredTime" label="解锁时间" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.lockExpiredTime == null" style="color:#DD3071">-</span>
                      <span v-else style="color:#28C6A2">{{scope.row.lockExpiredTime}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="orgName" label="所属组织" width="150" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip></el-table-column>
                  <el-table-column fixed="right" label="操作" width="260">
                    <template slot-scope="scope">
                      <el-button :style="{color:(scope.row.orgName == '终端用户'?'#ccc':'')}" :disabled="scope.row.orgName == '终端用户'" v-if="true ||rolePermit('org:user:edit')" class="editBtn" type="text" icon="el-icon-edit-outline" @click="showEditForm(scope.row.id)">编辑</el-button>
                      <el-button :style="{color:(scope.row.orgName == '终端用户'?'#ccc':'')}" :disabled="scope.row.orgName == '终端用户'" class="editBtn" v-if="scope.row.isLock /*isPermit('user:del')*/" type="text" icon="el-icon-unlock" @click="unlockUser(scope.row)">解锁</el-button>
                      <el-button :style="{color:(scope.row.orgName == '终端用户'?'#ccc':'#DD3071')}" :disabled="scope.row.orgName == '终端用户'" class="delBtn" v-else type="text" icon="el-icon-unlock" @click="lockUser(scope.row)">锁定</el-button>
                      <el-button :style="{color:(scope.row.orgName == '终端用户'?'#ccc':'#DD3071')}" :disabled="scope.row.orgName == '终端用户'" class="editBtn" v-if="scope.row.isEnabled /*isPermit('user:del')*/" type="text" icon="el-icon-unlock" @click="disabledUser(scope.row)">禁用</el-button>
                      <el-button :style="{color:(scope.row.orgName == '终端用户'?'#ccc':'')}" :disabled="scope.row.orgName == '终端用户'" class="delBtn" v-else type="text" icon="el-icon-unlock" @click="enabledUser(scope.row)">启用</el-button>
                      <el-button :style="{color:(scope.row.orgName == '终端用户'?'#ccc':'#DD3071')}" :disabled="scope.row.orgName == '终端用户'" v-if="true ||rolePermit('org:user:del')" class="delBtn" type="text" icon="el-icon-delete" @click="del(scope.row.id)">删除</el-button>
                    </template>
                  </el-table-column>
                  <!-- </el-table> -->
                  <!-- <div class="hasNoData" v-if="noData">
                  <div class="noDataImg"><img src="../../../../static/img/noData.png" alt=""></div>
                  <p>暂无数据</p>
                </div> -->
                </border-table>
              </div>

              <!-- <div class="pageBox">
                <el-pagination class="pages" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-drawer class="InstitutionManagementDD" title="组织维护" size="450px" :modal="false" :visible.sync="addModel" @close="closeAddModel" :wrapperClosable="false" direction="rtl" ref="drawer">
      <!-- <drawer-dialog class="InstitutionManagementDD" :drawerShow.sync="addModel" @closed="closeAddModel" drawerTitle="组织维护"> -->
      <div class="drawerWrap">
        <div class="drawerBody">
          <el-form :model="addForm" ref="addForm" :rules="orgRules" class="formBox" label-position="right" label-width="120px">
            <el-form-item label="组织名称" prop="name">
              <el-input maxlength="15" placeholder="请输入组织名称" v-model="addForm.name"></el-input>
            </el-form-item>
            <el-form-item label="序号" prop="">
              <el-input-number v-model="addForm.serial" :min="1" :max="100" label="序号"></el-input-number>
            </el-form-item>
            <!-- <el-form-item class="handlerBox">
              <el-button type="primary" plain @click="addOrUpdateOperation">{{isAddOperation ? "添加" : "编辑"}}</el-button>
              <el-button v-show="isAddOperation" @click="resetValue('addForm')">重置</el-button>
              <el-button @click="cancelTreeModel('addForm')">取消</el-button>
            </el-form-item> -->
          </el-form>
        </div>
        <div class="drawerFoot">
          <el-button type="primary" @click="addOrUpdateOperation">{{isAddOperation ? "添加" : "编辑"}}</el-button>
          <el-button v-show="isAddOperation" @click="resetValue('addForm')">重置</el-button>
          <el-button @click="cancelTreeModel('addForm')">取 消</el-button>
        </div>
      </div>
    </el-drawer>
    <!-- </drawer-dialog> -->
    <el-drawer class="InstitutionManagementDD" title="添加用户" size="900px" :modal="false" :visible.sync="isShowAddForm" @close="closeAddForm" :wrapperClosable="false" direction="rtl" ref="drawer">
      <!-- <drawer-dialog class="InstitutionManagementDD" :drawerShow.sync="isShowAddForm" @closed="closeAddForm" drawerTitle="添加用户"> -->
      <div class="drawerWrap">
        <div class="drawerBody">
          <el-form class="formBox1" ref="adduserForm" :model="adduserForm" :rules="rules" label-position="right" label-width="160px">
            <el-form-item label="用户昵称" prop="nickName">
              <el-input v-model="adduserForm.nickName" minlength="2" maxlength="30" placeholder="请输入用户昵称"></el-input>
            </el-form-item>

            <!-- <el-form-item label="用户手机号" prop="tel">
              <el-input v-model="adduserForm.tel" minlength="7" maxlength="11" placeholder="请输入用户手机号"></el-input>
            </el-form-item> -->

            <el-form-item label="用户手机号" prop="tel">
              <el-tag v-for="(item, index) in editPhoneList" :key="index" closable :disable-transitions="false" @close="handleClose(item)">
                {{ item }}
              </el-tag>
              <el-input v-show="inputVisible" :maxlength="15" class="input-new-tag" v-model="inputValue" ref="saveTagInput" size="small" placeholder="请输入手机号"  @keyup.enter.native="handleInputConfirm('adduserForm')" @blur="handleInputConfirm('adduserForm')">
              </el-input>
              <el-button v-show="plusButtonShow" class="plus-btn" type="primary" icon="el-icon-plus" @click="showInput"></el-button>
            </el-form-item>

            <el-form-item class="belongTypeItem" label="组织机构" prop="orgId">
              <treeselect
                v-model="adduserForm.orgId"
                :options="orgOption"
                :multiple="false"
                :load-options="loadOptions"
                @select="handleInputOrg"
                placeholder="请选择组织机构"/>
              <!-- <treeselect v-model="adduserForm.orgId" :normalizer="normalizer" :flat="true" :multiple="false" :defaultExpandLevel="Infinity" :options="orgOptions" placeholder="请选择组织机构" @select="handleInputOrg" /> -->
            </el-form-item>

            <el-form-item label="用户邮箱" v-show="isWxUser">
              <el-input v-model="adduserForm.email" placeholder="请输入用户邮箱"></el-input>
            </el-form-item>

            <el-form-item label="是否可登录" prop="flag">
              <el-switch v-model="adduserForm.flag" active-text="可登录" inactive-text="不可登录"></el-switch>
            </el-form-item>

            <!-- <div v-if="adduserForm.flag?true:false"> -->
              <el-form-item label="用户登录名" prop="loginName" v-if="adduserForm.flag?true:false">
                <el-input v-model="adduserForm.loginName" minlength="2" maxlength="20" placeholder="请输入用户登录名"></el-input>
              </el-form-item>
              <el-form-item label="用户密码" prop="pwd" v-if="adduserForm.flag?true:false">
                <el-input v-model="adduserForm.pwd" minlength="8" maxlength="30" placeholder="请输入用户密码" show-password></el-input>
              </el-form-item>
            <!-- </div> -->
            <el-form-item class="belongTypeItem" label="负责区域" prop="" v-if="adduserForm.flag&&(nameLists&&nameLists.length)&&filtersName('负责人角色')">
              <el-select v-model="mineStatus" placeholder="请选择" multiple collapse-tags @change="selectChange" clearable>
                <el-option :value="mineStatusValue" style="height: auto">
                  <el-tree
                    lazy
                    :load="loadData"
                    :props="props"
                    v-if="1"
                    class="tree"
                    ref="tree"
                    node-key="id"
                    highlight-current
                    :expand-on-click-node="false"
                    show-checkbox
                    :check-strictly="true"
                    @check-change="handleCheckChange">
                    <span class="custom-tree-node" slot-scope="{ node }">
                      <el-tooltip :content="node.label" placement="right-end" effect="light" :visible-arrow="true">
                        <span class="treeLabel" style="width:190px">{{ showLabel(node.label) }}</span>
                      </el-tooltip>
                    </span>
                  </el-tree>
                  <!-- <el-tree :data="regionOptions" :check-strictly="true" show-checkbox node-key="id" ref="tree" default-expand-all highlight-current :props="defaultProps" @check-change="handleCheckChange"></el-tree> -->
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="belongTypeItem" label="安装区域" prop="" v-if="adduserForm.flag&&(nameLists&&nameLists.length)&&filtersName('安装员角色')">
              <el-select v-model="mineStatus1" placeholder="请选择" multiple collapse-tags @change="selectChange1" clearable>
                <el-option :value="mineStatusValue1" style="height: auto">
                  <el-tree
                    lazy
                    :load="loadData"
                    :props="props"
                    v-if="1"
                    class="tree"
                    ref="tree1"
                    node-key="id"
                    highlight-current
                    :expand-on-click-node="false"
                    show-checkbox
                    :check-strictly="true"
                    @check-change="handleCheckChange1">
                    <span class="custom-tree-node" slot-scope="{ node }">
                      <el-tooltip :content="node.label" placement="right-end" effect="light" :visible-arrow="true">
                        <span class="treeLabel" style="width:190px">{{ showLabel(node.label) }}</span>
                      </el-tooltip>
                    </span>
                  </el-tree>
                  <!-- <el-tree :data="regionOptions" :check-strictly="true" show-checkbox node-key="id" ref="tree1" default-expand-all highlight-current :props="defaultProps" @check-change="handleCheckChange1"></el-tree> -->
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="请为用户分配角色" v-if="adduserForm.flag?true:false" prop="roleIdList"><br />
              <el-transfer @change="changeVal" :titles="['未选', '已选']" :button-texts="['', '']" v-model="adduserForm.roleIdList" :props="{key: 'id',label: 'name'}" :data="roleOptions">
              </el-transfer>
            </el-form-item>
          </el-form>
        </div>
        <!-- <div class="confirm">
        <el-button class="" type="primary" plain @click="add">添 加</el-button>
      </div> -->
        <div class="drawerFoot">
          <el-button type="primary" @click="add">添加</el-button>
          <!-- <el-button v-show="isAddOperation" @click="resetValue('addForm')">重置</el-button> -->
          <el-button @click="cancelTreeModel1('adduserForm')">取 消</el-button>
        </div>
      </div>
    </el-drawer>
    <!-- </drawer-dialog> -->
    <el-drawer class="InstitutionManagementDD" title="编辑用户" size="900px" :modal="false" :visible.sync="isShowEditForm" @close="closeEditForm" :wrapperClosable="false" direction="rtl" ref="drawer">
      <!-- <drawer-dialog class="InstitutionManagementDD" :drawerShow.sync="isShowEditForm" @closed="closeEditForm" drawerTitle="编辑用户"> -->
      <div class="drawerWrap">
        <div class="drawerBody">
          <el-form class="formBox1" ref="editForm" :model="editForm" :rules="rules1" label-position="right" label-width="160px">
            <el-form-item label="ID" prop="id" style="display:none;">
              <el-input v-model="editForm.id"></el-input>
            </el-form-item>

            <el-form-item label="用户昵称" prop="nickName">
              <el-input v-model="editForm.nickName" minlength="2" maxlength="10" placeholder="请输用户昵称"></el-input>
            </el-form-item>

            <el-form-item label="用户手机号" prop="tel">
              <el-tag v-for="(item, index) in editPhoneList" :key="index" closable :disable-transitions="false" @close="handleClose(item)">
                {{ item }}
              </el-tag>
              <el-input v-show="inputVisible" maxlength="15" class="input-new-tag" v-model="inputValue" ref="saveTagInput" size="small" placeholder="请输入手机号" @keyup.enter.native="handleInputConfirm('editForm')" @blur="handleInputConfirm('editForm')">
              </el-input>
              <el-button v-show="plusButtonShow" class="plus-btn" type="primary" icon="el-icon-plus" @click="showInput"></el-button>
              <!-- <el-input v-model="editForm.tel" minlength="7" maxlength="11" placeholder="请输入用户手机号"></el-input> -->
            </el-form-item>

            <el-form-item class="belongTypeItem" label="组织机构" prop="orgId">
              <treeselect
                :multiple="false"
                :options="orgOption"
                :load-options="loadOptions"
                @select="handleInputOrg"
                v-model="editForm.orgId"
                :normalizer="normalizer"
                placeholder="请选择区域" />
              <!-- <treeselect v-model="editForm.orgId" :normalizer="normalizer" :flat="true" :multiple="false" :defaultExpandLevel="Infinity" :options="orgOptions" placeholder="请选择组织机构" @select="handleInputOrg" /> -->
            </el-form-item>
            <el-form-item label="用户邮箱" prop="email" v-show="isWxUser">
              <el-input v-model="editForm.email" placeholder="请输入用户邮箱"></el-input>
            </el-form-item>

            <el-form-item label="是否可登录" prop="flag">
              <el-switch v-model="editForm.flag" active-text="可登录" inactive-text="不可登录" @change="change"></el-switch>
            </el-form-item>

            <!-- <el-form-item label="用户登录名" v-if="editForm.flag?true:false" prop="loginName" :rules="[{ required:editForm.flag ? true : false, message: '请输入用户登录名', trigger: 'blur' },{
                min: 2,
                max: 20,
                message: '用户登录名长度在 2 到 20 个字符',
                trigger: 'blur'
              }]"> -->
            <el-form-item label="用户登录名" v-if="editForm.flag?true:false" prop="loginName">
              <el-input v-model="editForm.loginName" minlength="2" maxlength="20" placeholder="请输入用户登录名"></el-input>
            </el-form-item>

            <el-form-item label="是否重设密码" v-if="editForm.flag&&oldAuthFlag">
              <el-switch v-model="editForm.resetPwd" active-text="重设" inactive-text="不重设"></el-switch>
            </el-form-item>

            <el-form-item label="用户密码" v-if="editForm.flag&&(!oldAuthFlag||editForm.resetPwd)?true:false" prop="pwd">
              <el-input v-model="editForm.pwd" minlength="6" maxlength="20" placeholder="请输入用户密码" show-password></el-input>
            </el-form-item>

            <el-form-item class="belongTypeItem" label="负责区域" prop="" v-if="editForm.flag&&(nameLists&&nameLists.length)&&filtersName('负责人角色')">
              <el-select v-model="mineStatus" placeholder="请选择" multiple collapse-tags @change="selectChange" clearable>
                <el-option :value="mineStatusValue" style="height: auto">
                  <el-tree
                    lazy
                    :load="loadData"
                    :props="props"
                    v-if="1"
                    class="tree"
                    ref="tree"
                    node-key="id"
                    highlight-current
                    :expand-on-click-node="false"
                    show-checkbox
                    :check-strictly="true"
                    @check-change="handleCheckChange">
                      <span class="custom-tree-node" slot-scope="{ node }">
                        <el-tooltip :content="node.label" placement="right-end" effect="light" :visible-arrow="true">
                          <span class="treeLabel" style="width:190px">{{ showLabel(node.label) }}</span>
                        </el-tooltip>
                      </span>
                    </el-tree>
                  <!-- <el-tree :data="regionOptions" :check-strictly="true" show-checkbox node-key="id" ref="tree" default-expand-all highlight-current :props="defaultProps" @check-change="handleCheckChange"></el-tree> -->
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="belongTypeItem" label="安装区域" prop="" v-if="editForm.flag&&(nameLists&&nameLists.length)&&filtersName('安装员角色')">
              <el-select v-model="mineStatus1" placeholder="请选择" multiple collapse-tags @change="selectChange1" clearable>
                <el-option :value="mineStatusValue1" style="height: auto">
                  <el-tree
                    lazy
                    :load="loadData"
                    :props="props"
                    v-if="1"
                    class="tree"
                    ref="tree1"
                    node-key="id"
                    highlight-current
                    :expand-on-click-node="false"
                    show-checkbox
                    :check-strictly="true"
                    @check-change="handleCheckChange1">
                    <span class="custom-tree-node" slot-scope="{ node }">
                      <el-tooltip :content="node.label" placement="right-end" effect="light" :visible-arrow="true">
                        <span class="treeLabel" style="width:190px">{{ showLabel(node.label) }}</span>
                      </el-tooltip>
                    </span>
                  </el-tree>
                  <!-- <el-tree :data="regionOptions" :check-strictly="true" show-checkbox node-key="id" ref="tree1" default-expand-all highlight-current :props="defaultProps" @check-change="handleCheckChange1"></el-tree> -->
                </el-option>
              </el-select>
            </el-form-item>
            
            <el-form-item v-if="editForm.flag?true:false" label="请为用户分配角色" prop="roleIdList"><br />
              <el-transfer @change="changeVal" :titles="['未选', '已选']" :button-texts="['', '']" v-model="editForm.roleIdList" :props="{key: 'id',label: 'name'}" :data="roleOptions">
              </el-transfer>
            </el-form-item>
          </el-form>
        </div>
        <div class="drawerFoot">
          <el-button type="primary" @click="edit(editForm.id)" show-password>编 辑</el-button>
          <!-- <el-button v-show="isAddOperation" @click="resetValue('addForm')">重置</el-button> -->
          <el-button @click="cancelTreeModel2('editForm')">取 消</el-button>
        </div>
      </div>
      <!-- <div class="confirm">
        <el-button class="" type="primary" plain @click="edit(editForm.id)" show-password>编 辑</el-button>
      </div> -->

      <!-- </drawer-dialog> -->
    </el-drawer>
  </div>
</div>
</template>

<script>
// import DrawerDialog from "@/components/common/DrawerDialog1";
import BorderTable from "@/components/common/BorderTable";
import {LOAD_CHILDREN_OPTIONS, Treeselect} from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { checkKeyboardContinuousChar } from '@/utils/validate'
var md5 = require("js-md5");
// import { md5 } from 'md5js';
const defaultTreeForm = {
  name: "",
  serial: 50
};
export default {
  components: {
    // DrawerDialog,
    Treeselect,
    BorderTable
  },
  data() {
    const validatePasswd = (rule, value, callback) => {
      // 必须包含大小写字母、数字、特殊字符
      const regex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&+=_！]).+$/
      //不能相同字符（如111、aaa）连续3位或3位以上
      const regex1 = /(\w)*(\w)\2{2}(\w)*/g

      if (value === '') {
        callback(new Error('请输入租户密码'));
      } else if (value.length < 8 || value.length > 30) {
        callback(new Error('租户密码必须在8~30个字符之间'));
      } else if (!regex.test(value)) {
        callback(new Error('密码必须包含大小写字母、数字、特殊字符[!@#$%^&+=_]'))
      } else if (regex1.test(value)) {
        callback(new Error('密码不能含有相同字符（例如111、aaa）连续3位或3位以上'))
      } else if (checkKeyboardContinuousChar(value)) {
        callback(new Error('密码不能含有标准键相邻按键组合（例如ASDFG,QWERTY）'))
      } else {
        // 不能连续字符（如123、abc）连续3位或3位以上
        for (let i = 1; i < value.length - 1; i++) {
          let firstIndex = value[i - 1].charCodeAt()
          let secondIndex = value[i].charCodeAt()
          let thirdIndex = value[i + 1].charCodeAt()
          if ((thirdIndex - secondIndex == 1) && (secondIndex - firstIndex == 1)) {
            callback(new Error('密码禁止设置递增的字母或数字（例如abc,123）连续3位或3位以上!'))
          } else {
            callback()
          }
        }
      }
    };
    const validateEmailNumber = (rule, value, callback) => {
      const cellphone = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
      if (!value) {
        callback(new Error('邮箱地址不能为空'));
        this.emileflag = false;
      } else {
        if (!cellphone.test(value)) {
          callback(new Error('您输入的邮箱地址格式不正确'));
          this.emileflag = false;
        } else {
          callback()
        }
      }
      
      // if (!value) {
      //   callback()
      // } else {
      //   if (!cellphone.test(value)) {
      //     callback(new Error('您输入的邮箱地址格式不正确'));
      //     this.emileflag = false;
      //   } else {
      //     callback()
      //   }
      // }
    };
    return {
      mineStatus: [],
      mineStatusValue: [],
      mineStatus1: [],
      mineStatusValue1: [],
      props: {
        label: 'label',
        children: 'children',
        isLeaf: 'isLeaf'
      },
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      rolesLoading: false,
      addUserRole: false,
      editUserRole: false,
      goonComm: true,
      noData: false,
      tableMaxHeight: 0,
      orgExpandedKeys: [],
      treeData: [],
      currentTreeId: 0,
      treeHandler: false,
      isforbid: false,
      addModel: false,
      isAddOperation: true,
      addForm: defaultTreeForm,
      name: "",
      role: "",
      status: "",
      roles: [],
      loading: true,
      admins: [],
      privilegeGroupInfos: [],
      // currentPage: 1,
      // pageSize: 10,
      // total: 0,
      sort: "createTime",
      order: "desc",
      isAddOperation: true,

      orgOption:[{
        id: 0,
        label: '组织机构',
        value: 0,
        isDefaultExpanded: true,
        children: null
      }],
      orgOptions: [],
      roleOptions: [],
      // 添加
      isShowAddForm: false,
      adduserForm: {
        nickName: "",
        tel: "",
        email: "",
        orgId: null,
        createType: 0,
        flag: false,
        loginName: "",
        pwd: "",
        roleIdList: [],
        chargeRegionIdList: [],
        installRegionIdList: []
      },
      // 编辑
      isShowEditForm: false,
      oldAuthFlag: false,
      editForm: {
        id: "",
        nickName: "",
        tel: "",
        email: "",
        orgId: null,
        loginName: "",
        pwd: "",
        roleIdList: [],
        resetPwd: false,
        flag: false,
        chargeRegionIdList: [],
        installRegionIdList: []
      },
      orgRules: {
        name: [{
            required: true,
            message: "请输入组织名称",
            trigger: "blur"
          },
          {
            pattern: /^[0-9a-zA-Z\u4E00-\u9FA5\(\)]*$/gi,
            message: "组织名称格式为中文、字母、数字组成",
            trigger: "blur"
          },
          {
            min: 1,
            max: 15,
            message: "组织名称长度在 1 到 15 个字符",
            trigger: "change"
          }
        ],
        code: [{
            required: true,
            message: "请输入组织代码",
            trigger: "blur"
          },
          {
            min: 1,
            max: 30,
            message: "组织代码长度在 1 到 30 个字符",
            trigger: "change"
          }
        ]
      },
      rules: {
        roleIdList: [{
            required: true,
            message: " ",
            trigger: "blur"
          },
        ],
        nickName: [{
            required: true,
            message: "请输入用户昵称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 20,
            message: "用户昵称长度在 1 到 20 个字符",
            trigger: "blur"
          }
        ],
        tel: [{
            required: true,
            message: "请添加手机号码",
            trigger: "blur"
          },
          // {
          //   pattern: /^[1][3|4|5|6|7|8|9][0-9]{9}$/,
          //   message: "请输入正确格式的手机号码",
          //   trigger: "blur"
          // }
        ],
        email: [{
          required: true,
          validator: validateEmailNumber,
          trigger: 'blur'
        }],
        orgId: [{
          required: true,
          message: " ",
          trigger: "change"
        }],
        loginName: [{
            required: true,
            message: "请输入登录名",
            trigger: "blur"
          },
          {
            pattern: /^[a-z0-9]*$/gi,
            message: "登录名格式不正确，必须为字母、数字组成",
            trigger: "blur"
          },
          {
            min: 2,
            max: 20,
            message: "登录名长度必须是2-20位",
            trigger: "blur"
          }
        ],
        pwd: [{
          required: true,
          validator: validatePasswd,
          trigger: 'blur'
        }],
      },
      rules1: {
        roleIdList: [{
            required: true,
            message: " ",
            trigger: "blur"
          },
        ],
        nickName: [{
            required: true,
            message: "请输入用户昵称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 20,
            message: "用户昵称长度在 1 到 20 个字符",
            trigger: "blur"
          }
        ],
        tel: [{
            required: true,
            message: "请添加手机号码",
            trigger: "blur"
          },
          // {
          //   pattern: /^[1][3|4|5|6|7|8|9][0-9]{9}$/,
          //   message: "请输入正确格式的手机号码",
          //   trigger: "blur"
          // }
        ],
        email: [{
          required: true,
          validator: validateEmailNumber,
          trigger: 'blur'
        }],
        orgId: [{
          required: true,
          message: " ",
          trigger: "change"
        }],
        loginName: [{
            required: true,
            message: "请输入登录名",
            trigger: "blur"
          },
          {
            pattern: /^[a-z0-9]*$/gi,
            message: "登录名格式不正确，必须为字母、数字组成",
            trigger: "blur"
          },
          {
            min: 2,
            max: 20,
            message: "登录名长度必须是2-20位",
            trigger: "blur"
          }
        ],
        pwd: [{
          required: true,
          validator: validatePasswd,
          trigger: 'blur'
        }]
      },
      isSearchInput: false,
      isValueInput: false,
      isTestTimeInput: false,
      queryForm: {
        nickName: "",
        email: "",
        tel: "",
        orgId: this.currentTreeId,
        roleIds: "",
        order: "desc",
        sort: "createTime",
        isEnabled: ''
      },
      roles: [],
      queryFormRoles: [],
      tableMaxHeight: 0,
      minvalue: "",
      maxvalue: "",
      // currentPage: 1,
      // total: 0,
      // pageSize: 10,
      actionQueryData: [],
      disposeAlcoDialog: true,
      auditAlcoDialog: false,
      disposeAlcoForm: {},
      auditAlcoForm: {},
      disposeAlcoFormRules: {},

      drawerBoxShow: false,
      adddrawerBox: false,
      styleObject: {
        height: ""
      },
      editPhoneList: [],
      inputVisible: false,
      inputValue: '',
      plusButtonShow: true,
      isWxUser: true,
      temp: [{
        required: true,
        validator: (rule, value, callback) => {
          const cellphone = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
          if (!value) {
            callback(new Error('邮箱地址不能为空'));
            this.emileflag = false;
          } else {
            if (!cellphone.test(value)) {
              callback(new Error('您输入的邮箱地址格式不正确'));
              this.emileflag = false;
            } else {
              callback()
            }
          }
        },
        trigger: 'blur'
      }],
      loginNameRules: [{
          required: true,
          message: "请输入登录名",
          trigger: "blur"
        },
        {
          pattern: /^[a-z0-9]*$/gi,
          message: "登录名格式不正确，必须为字母、数字组成",
          trigger: "blur"
        },
        {
          min: 2,
          max: 20,
          message: "登录名长度必须是2-20位",
          trigger: "blur"
        }
      ],
      regionOptions: [],
      nameLists:[],
      treeFlag: false,
      orgName: ''
    };
  },
  created() {
    this.makeheight()
    // this.showRegionOptions()
    // this.query();
    // this.queryRole();
    // this.searchAlco();
    if (this.getViewportSize.height > 768) {
      this.tableMaxHeight = this.getViewportSize.height - 376;
    } else {
      this.tableMaxHeight = 400;
    }
  },
  methods: {
    // 查询组织
    orgLoadData (node, resolve) {
      this.node = node
      this.resolve = resolve
      if (node.level === 0) {
        let root = { id: 0, label: '组织机构', parentId: 0, value: 0, disabled: true }
        
        //默认展开第一层根节点---节点渲染完成后，加载第二层节点的核心代码
        this.$nextTick(() => {
          this.$refs.orgtree.setCurrentKey(0)
          let nodedata = node.childNodes[0];
          nodedata.expanded = true;
          nodedata.loadData();
        })
        resolve([root])
      } else {
        let pid = node.data ? node.data.id : 0

        this.request.get(`/front/system/organization/findTreefenjiById?id=${pid}`).then(rs => {
          let data = rs.code === 200 ? rs.data : []

          resolve(data)
          
        }).catch(error => {
          console.error(error)
          resolve([])
        })
      }
    },
    // 查询区域
    loadData (node, resolve) {
      if (node.level === 0) {
        let root = { id: 0, label: '区域机构', parentId: 0, value: 0, disabled: true }
        
        //默认展开第一层根节点---节点渲染完成后，加载第二层节点的核心代码
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(0)
          let nodedata = node.childNodes[0];
          nodedata.expanded = true;
          nodedata.loadData();
        })
        resolve([root])
      } else {
        let pid = node.data ? node.data.id : 0

        this.request.get(`/front/device/region/findTreeNofenjiById?id=${pid}`).then(rs => {
          let data = rs.code === 200 ? rs.data : []
          // 编辑-赋值
          if (this.isShowEditForm) {
            this.$nextTick(() => {
              if(this.$refs.tree){
                this.$refs.tree.setCheckedNodes(this.mineStatusValue); //设置勾选的值
              }
              if(this.$refs.tree1){
                this.$refs.tree1.setCheckedNodes(this.mineStatusValue1); //设置勾选的值
              }
            })
          }

          resolve(data)
          
        }).catch(error => {
          console.error(error)
          resolve([])
        })        
      }
    },
    loadOptions({ action, parentNode, callback }) {
      if (action === LOAD_CHILDREN_OPTIONS) {
        let id = parentNode.id
        this.getTreeNode(id).then(res => {
          if (res.code === 200) {
            let children = res.data && res.data.map(item => {
              if (item.label == '终端用户') item.isDisabled = true
              if (!item.isLeaf) item.children = null
              return item
            })
            parentNode.children = children
          }
          callback()
        })
      }
    },
    getTreeNode (pid = 0) {
      return new Promise((resolve, reject) => {
        this.request.get(`/front/system/organization/findTreefenjiById?id=${pid}`).then(res => {
          resolve(res)
        }).catch(e => reject(e))
      })
    },
    changeVal(e){
      // console.log(e);
      let arr3 = []
      e.forEach(num=>{
        this.roleOptions.forEach(item=>{
          if(item.id == num){
            arr3.push(item.name)
          }
        })
      })
      console.log(arr3);
      this.nameLists = arr3
      let flag = false
      let flag1 = false
      arr3.forEach(val=>{
        if(val=="安装员角色"){
          flag1 = true
        }
        if(val=="负责人角色"){
          flag = true
        }
      })
      if(!flag1){
        this.mineStatus1 = []
        this.mineStatusValue1 = []
        this.adduserForm.installRegionIdList = []
        this.editForm.installRegionIdList = []
      }
      if(!flag){
        this.mineStatus = []
        this.mineStatusValue = []
        this.adduserForm.chargeRegionIdList = []
        this.editForm.chargeRegionIdList = []
      }
    },
    filtersName(e){
      let arr = this.nameLists;
      let res = arr.filter(function(item,index,array){
          //元素值，元素的索引，原数组。
          return item == e
      });
      if(res[0]==e){
        return true
      }
    },
    showRegionOptions() {
      let params ={
        id : 0
      }
      this.request
        .get("/front/device/region/findTreeNoTerminalById",params)
        .then(rs => {
          if (200 === rs.code) {
            let RegionArr = rs.data;
            this.regionOptions = RegionArr && RegionArr.length ? RegionArr : [];
            this.regionOptions.forEach(items=>{
              if(items.id == 0){
                items.disabled = true
              }
            })
            this.addAttr(this.regionOptions[0].children)
          } else {
            this.msg.error(rs.msg);
          }
        })
        .catch(e => this.msg.error(e));
    },
    addAttr(data) {
      // console.log(data);
      if(data&&data.length){
        data.forEach(item => {
          if (item.terminalFlag == 1) {
            item.disabled = true;
            if (item.children && item.children.length !== 0) {
              this.addAttr(item.children);
            }
          }
        });
      }
    },
    //select框值改变时候触发的事件
    selectChange(e) {
      var arrNew = [];
      var dataLength = this.mineStatusValue.length;
      var eleng = e.length;
      for (let i = 0; i < dataLength; i++) {
        for (let j = 0; j < eleng; j++) {
          if (e[j] === this.mineStatusValue[i].label) {
            arrNew.push(this.mineStatusValue[i])
          }
        }
      }
      console.log(arrNew);
      this.$refs.tree.setCheckedNodes(arrNew); //设置勾选的值
    },
    //select框值改变时候触发的事件
    selectChange1(e) {
      var arrNew = [];
      var dataLength = this.mineStatusValue1.length;
      var eleng = e.length;
      for (let i = 0; i < dataLength; i++) {
        for (let j = 0; j < eleng; j++) {
          if (e[j] === this.mineStatusValue1[i].label) {
            arrNew.push(this.mineStatusValue1[i])
          }
        }
      }
      // console.log(arrNew);
      this.$refs.tree1.setCheckedNodes(arrNew); //设置勾选的值
    },
    handleCheckChange() {
      let res = this.$refs.tree.getCheckedNodes(false, false); //这里两个true，1. 是否只是叶子节点 2. 是否包含半选节点（就是使得选择的时候不包含父节点）
      let arrLabel = [];
      let arr = [];
      res.forEach(item => {
        arrLabel.push(item.label);
        arr.push(item);
      });
      this.mineStatusValue = arr;
      this.mineStatus = arrLabel;
      // console.log('arr:' + JSON.stringify(arr))
      // console.log('arrLabel:' + arrLabel)
      this.editForm.chargeRegionIdList = []
      this.adduserForm.chargeRegionIdList = []
      this.mineStatusValue.forEach(item=>{
        this.editForm.chargeRegionIdList.push(item.id)
        this.adduserForm.chargeRegionIdList.push(item.id)
      })
      // console.log(this.queryForm.chargeRegionIdList);
    },
    handleCheckChange1() {
      let res = this.$refs.tree1.getCheckedNodes(false, false); //这里两个true，1. 是否只是叶子节点 2. 是否包含半选节点（就是使得选择的时候不包含父节点）
      let arrLabel = [];
      let arr = [];
      res.forEach(item => {
        arrLabel.push(item.label);
        arr.push(item);
      });
      this.mineStatusValue1 = arr;
      this.mineStatus1 = arrLabel;
      // console.log('arr:' + JSON.stringify(arr))
      // console.log(arr)
      // console.log(arrLabel)
      this.editForm.installRegionIdList = []
      this.adduserForm.installRegionIdList = []
      this.mineStatusValue1.forEach(item=>{
        this.editForm.installRegionIdList.push(item.id)
        this.adduserForm.installRegionIdList.push(item.id)
      })
    },
    change(data) {
      console.log(data)
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      _this.tableHeight = window.innerHeight - 340;
      // console.log(_this.tableHeight);
      window.onresize = () => {
        return (() => {
          _this.tableHeight = window.innerHeight - 340;
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    isTenant() {
      let orgId = sessionStorage.getItem("orgId");
      return "0" === orgId;
    },
    queryAllRoles(visible) {
      if (!visible) return;
      this.request.get(`/front/system/role/query/all`)
        .then(rs => {
          if (rs.code === 200) {
            this.roles = rs.data;
          }
        })
        .catch(error => (this.roles = []));
    },
    showLabel(label) {
      if (!label) {
        return label;
      }
      return label;
    },
    // 查询组织
    queryTreeNode(pid = 0) {
      this.request.get(`/front/system/organization/findTreeById?id=${pid}`)
        .then(rs => {
          this.treeData = rs.code === 200 ? rs.data : [];
          this.currentTreeId = this.treeData.length > 0 ? this.treeData[0].value : 0;
          //设置选中
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(this.treeData[0].value)
          })
          this.queryAlcoInfo(1, this.pagination.pageSize);
        })
        .catch(error => (this.treeData = []));
    },
    lockUser(row) {
      this.$confirm('此操作将锁定该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.request.post(`/front/system/user/lock/${row.id}`).then(rs => {
          if (rs.code === 200) {
            this.searchAlco();
            this.msg.success('锁定成功')
          } else {
            this.msg.error(rs.msg)
          }
        })
      }).catch(() => {
        this.msg.info('已取消锁定')
      });
    },
    unlockUser(row) {
      this.$confirm('此操作将解锁该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.request.post(`/front/system/user/unlock/${row.id}`).then(rs => {
          if (rs.code === 200) {
            this.searchAlco();
            this.msg.success('解锁成功')
          } else {
            this.msg.error(rs.msg)
          }
        })
      }).catch(() => {
        this.msg.info('已取消解锁')
      });
    },
    disabledUser(row) {
      this.$confirm('此操作将禁用该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.request.post(`/front/system/user/disabled/${row.id}`).then(rs => {
          if (rs.code === 200) {
            this.searchAlco();
            this.msg.success('禁用成功')
          } else {
            this.msg.error(rs.msg)
          }
        })
      }).catch(() => {
        this.msg.info('已取消禁用')
      });
    },
    enabledUser(row) {
      this.$confirm('此操作将启用该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.request.post(`/front/system/user/enabled/${row.id}`).then(rs => {
          if (rs.code === 200) {
            this.searchAlco();
            this.msg.success('启用成功')
          } else {
            this.msg.error(rs.msg)
          }
        })
      }).catch(() => {
        this.msg.info('已取消启用')
      });
    },
    addTreeNode(isReload = true) {
      let form = this.addForm;
      let submitForm = {
        serial: form.serial,
        name: form.name,
        parentId: this.currentTreeId
      };
      this.$refs["addForm"].validate(valid => {
        if (valid) {
          this.request.post("/front/system/organization/add", submitForm)
            .then(rs => {
              if (rs.code === 200) {
                this.$message({
                  type: "success",
                  message: `组织已添加!`
                });
                // this.orgExpandKeys[0] = this.currentTreeId;
                // if (isReload) this.queryTreeNode();
                if (isReload) this.orgLoadData(this.node, this.resolve)
                this.addModel = false;
              } else if (rs.code === 500) {
                this.$message({
                  type: "info",
                  message: `${rs.msg}`
                });
              }
            })
            .catch(error => {
              this.$message({
                type: "info",
                message: `操作失败!`
              });
            });
        } else {
          this.$message({
            type: "error",
            message: `表单验证失败!`
          });
        }
      });

    },
    editTreeNode(isReload = true) {
      let form = this.addForm;
      let submitForm = {
        id: form.id,
        serial: form.serial,
        name: form.name
      };

      this.$refs["addForm"].validate(valid => {
        if (valid) {
          this.request.post("/front/system/organization/update", submitForm)
            .then(rs => {
              if (rs.code === 200) {
                this.$message({
                  type: "success",
                  message: `编辑成功!`
                });
                // this.orgExpandKeys[0] = this.currentTreeId;
                // if (isReload) this.queryTreeNode();
                if (isReload) this.orgLoadData(this.node, this.resolve)
                this.addModel = false;
              } else if (rs.code === 500) {
                this.$message({
                  type: "info",
                  message: `${rs.msg}`
                });
              }
            })
            .catch(error => {
              this.$message({
                type: "info",
                message: `操作失败!`
              });
            });
        } else {
          this.$message({
            type: "error",
            message: `表单验证失败!`
          });
        }
      })

    },
    addOrUpdateOperation() {
      if (this.isAddOperation) {
        this.addTreeNode();
      } else {
        this.editTreeNode();
      }
    },
    closeAddModel() {
      this.addModel = false;
      // this.$refs["addForm"].resetFields();
    },
    // 移除组织
    removeTreeNode(data, isReload = true) {
      let id = data.value;
      let parentId = data.parentId;
      this.$confirm("此操作将永久删除该组织, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          this.request.delete(`/front/system/organization/${id}`)
            .then(rs => {
              if (rs.code === 200) {
                this.$message({
                  type: "success",
                  message: `组织已删除!`
                });
                // if (isReload) this.queryTreeNode();
                if (isReload) this.orgLoadData(this.node, this.resolve)
              } else if (rs.code === 500) {
                this.$message({
                  type: "info",
                  message: `${rs.msg}`
                });
              }
            })
            .catch(error => {
              return this.$message({
                type: "info",
                message: `删除失败!`
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 节点点击发生变化时，触发事件
    handleNodeSelect(item) {
      this.currentTreeId = item ? (item.value ? item.value : 0) : 0;
      this.queryForm.page = 1;
      this.treeFlag = (item.label=="终端用户"?true:false)
      this.queryAlcoInfo();
    },
    clickAddOrganize(data) {
      this.addForm = {
        name: "",
        serial: 50
      }
      if (data.isCommunity) {
        this.goonComm = false;
      }
      this.isAddOperation = true;
      this.handleNodeSelect(data);
      this.resetValue('addForm');
      this.addModel = true;
    },
    clickEditOrganize(data) {
      this.addForm = {
        name: "",
        serial: 50
      }
      this.isAddOperation = false;
      this.handleNodeSelect(data);
      this.addModel = true;
      this.request.get(`/front/system/organization/${data.value}`)
        .then(rs => {
          if (rs.code === 200) {
            this.addForm = {
              id: rs.data.id,
              name: rs.data.name,
              serial: rs.data.serial
            };
          } else {
            return this.$message({
              type: "info",
              message: `查询此组织不存在，编辑失败!`
            });
          }
        })
        .catch(error => {});
    },
    clickRemoveOrganize(node, data) {
      this.removeTreeNode(data);
    },
    // 重置表单值
    resetValue(formName) {
      if (this.$refs[formName] !== undefined) {
        this.$refs[formName].resetFields();
      }
      this.resetFromValue();
    },
    resetFromValue() {
      this.addForm = defaultTreeForm;
    },
    cancelTreeModel(formName) {
      this.addModel = false;
      this.resetValue(formName);
    },
    cancelTreeModel1(formName) {
      this.isShowAddForm = false;
      this.resetValue(formName);
    },
    cancelTreeModel2(formName) {
      this.isShowEditForm = false;
      this.resetValue(formName);
    },
    showOrgOptions() {
      this.request
        .get("/front/system/organization/findTreeById?id=0")
        .then(rs => {
          if (200 === rs.code) {
            let orgArr = rs.data;
            this.orgOptions = orgArr && orgArr.length ? orgArr : [];
          } else {
            this.msg.error(rs.msg);
          }
        })
        .catch(e => this.msg.error(e));
    },
    showRoleOptions() {
      this.request
        .get("/front/system/role/query/all")
        .then(rs => {
          if (200 === rs.code) {
            let roleIdList = rs.data;
            this.roleOptions =
              roleIdList && roleIdList.length ? roleIdList : [];
          } else {
            this.roleOptions = [];
          }
        })
        .catch(e => this.msg.error(e));
    },
    showAddForm() {
      this.mineStatus1 = []
      this.mineStatus = []
      this.nameLists = []
      this.adduserForm = {
        nickName: "",
        tel: "",
        email: "",
        orgId: null,
        createType: 0,
        flag: false,
        loginName: "",
        pwd: "",
        roleIdList: [],
        chargeRegionIdList:[],
        installRegionIdList:[]
      }

      this.editPhoneList = []
      this.inputVisible = true
      this.plusButtonShow = true
      this.handleInputOrg({
        label: ''
      })

      this.isShowAddForm = true;
      this.showOrgOptions();
      this.showRoleOptions();
      this.adduserForm.orgId = null;
    },
    closeAddForm() {
      this.isShowAddForm = false;
      this.$refs["adduserForm"].resetFields();
    },
    add() {
      this.adduserForm.tel = this.editPhoneList.join(';')

      this.$refs["adduserForm"].validate(valid => {
        if(this.editForm.orgId){
          return this.msg.warn('请先选择组织机构')
        }
        if (valid) {
          let form = {
            ...this.adduserForm
          };
          var reg = /^\d+$/;
          if (!form.orgId || !reg.test(form.orgId)) {
            return this.msg.error("请选择组织机构!");
          }
          if (!form.flag) {
            delete form.loginName;
            delete form.pwd;
            delete form.roleIdList
            delete form.chargeRegionIdList
            delete form.installRegionIdList
          } else {
            form.pwd = md5(form.pwd);
          }
          this.request
            .post("/front/system/user/add", form)
            .then(rs => {
              if (200 === rs.code) {
                this.msg.success("添加成功!");
                this.closeAddForm();
                this.searchAlco();
              } else if (500 === rs.code) {
                this.msg.error(rs.msg);
              }
            })
            .catch(e => this.msg.error(e));
        } else {
          this.$message.error("添加用户表单参数校验失败!!");
          return false;
        }
      });
    },
    showEditForm(id) {
      this.mineStatus = []
      this.mineStatusValue = []
      this.mineStatus1 = []
      this.mineStatusValue1 = []
      this.editPhoneList = []
      this.inputVisible = false;
      this.isShowEditForm = true;
      this.showOrgOptions();
      this.showRoleOptions();
      this.request.get(`/front/system/user/${id}`).then(rs => {
        if (rs.code === 200 && rs.data != null) {
          // 校验组织字段是否为组织机构
          this.handleInputOrg({
            label: rs.data.orgName
          })

          this.oldAuthFlag = rs.data.authId != null;
          let editForm = Object.assign({}, rs.data);

          this.orgName = rs.data.orgName

          editForm.flag = (rs.data.authId != null)
          // this.rules1.loginName[0].required = editForm.flag ? true : false
          this.loginNameRules[0].required = editForm.flag ? true : false
          editForm.roleIdList = editForm.roleIdList ? editForm.roleIdList : []
          // console.log(editForm.roleIdList);
          let arr3 = []
          editForm.roleIdList.forEach(num=>{
            this.roleOptions.forEach(item=>{
              if(item.id == num){
                arr3.push(item.name)
              }
            })
          })
          this.nameLists = arr3
          let arrList1 = []
          editForm.chargeRegionList.forEach(item=>{
            arrList1.push(item.id)
            this.mineStatus.push(item.name)
            this.mineStatusValue.push(item)
          })
          editForm.chargeRegionIdList = arrList1
          // this.$refs.tree.setCheckedKeys(this.mineStatusValue)
          let arrList2 = []
          editForm.installRegionList.forEach(item=>{
            arrList2.push(item.id)
            this.mineStatus1.push(item.name)
            this.mineStatusValue1.push(item)
          })
          editForm.installRegionIdList = arrList2

          this.editForm = Object.assign({}, editForm);

          // this.editForm.flag = (rs.data.authId != null);

          this.editPhoneList = rs.data.tel && rs.data.tel.split(';')

          this.plusButtonShow = this.editPhoneList.length < 3

          // setCheckedKeys
          this.$nextTick(() => {
            // console.log(this.$refs.tree);
            if(this.$refs.tree){
              this.$refs.tree.setCheckedNodes(this.mineStatusValue); //设置勾选的值
            }
            if(this.$refs.tree1){
              this.$refs.tree1.setCheckedNodes(this.mineStatusValue1); //设置勾选的值
            }
          })
        } else {
          this.msg.success("加载错误!");
        }
      });
    },
    closeEditForm() {
      this.isShowEditForm = false;
      this.$refs["editForm"].resetFields();
    },
    edit(id) {
      this.editForm.tel = this.editPhoneList.join(';')

      this.$refs["editForm"].validate(valid => {
        if (valid) {
          let form = {
            ...this.editForm
          };
          form.pwdChange = false;
          var reg = /^\d+$/;
          if (!form.orgId || !reg.test(form.orgId)) {
            return this.msg.error("请选择组织机构!");
          }
          if (!form.flag) {
            delete form.loginName;
            delete form.pwd;
            delete form.roleIdList
            delete form.chargeRegionIdList
            delete form.installRegionIdList
          } else {
            if (!this.oldAuthFlag || form.resetPwd) {
              form.pwd = md5(form.pwd);
              form.pwdChange = true;
            } else {
              delete form.pwd;
            }
          }
          this.request
            .post("/front/system/user/update", form)
            .then(rs => {
              if (200 === rs.code) {
                this.msg.success("编辑成功!");
                this.closeEditForm();
                this.searchAlco();
              } else if (500 === rs.code) {
                this.msg.error(rs.msg);
              }
            })
            .catch(e => this.msg.error(e));
        } else {
          this.$message.error("编辑用户表单参数校验失败!!");
          return false;
        }
      });
    },
    del(id) {
      this.$confirm("此操作将删除此用户, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          this.request.delete(`/front/system/user/${id}`).then(rs => {
            if (rs.code === 200) {
              this.msg.success("用户已删除!");
              this.queryAlcoInfo(1, this.pagination.pageSize);
            } else {
              this.msg.error("删除失败，" + rs.msg);
            }
          });
        })
        .catch(() => {
          this.msg.info("已取消删除");
        });
    },
    searchAlco() {
      this.pagination.currentPage = 1;
      this.queryAlcoInfo(this.pagination.currentPage, this.pagination.pageSize);
    },
    queryAlcoInfo(page, pageSize) {
      this.queryForm.orgId = this.currentTreeId ? this.currentTreeId : this.storage.getSession("orgId"),
      this.queryForm.roleIds = this.queryFormRoles.length == 0 ? "" : this.queryFormRoles.join(',');
      let params = Object.assign({}, this.queryForm, {
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        sort: this.sort,
        order: this.order,
      });
      this.request.get("/front/system/user/query", params).then(rs => {
        // console.log(rs);

        if (rs.code === 200) {
          this.actionQueryData = rs.data ? rs.data : [];
          this.pagination.total = rs.total;
          this.noData = false;
          if (!rs.total) {
            this.noData = true;
          }
        } else {
          this.actionQueryData = [];
          this.noData = true;
        }
      });
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.queryAlcoInfo(1, this.pagination.pageSize);
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.queryAlcoInfo(this.pagination.currentPage, this.pagination.pageSize);
    },
     //树形结构
    normalizer(node){
      // console.log(node);
      //去掉children=null的属性
      // if(node.children==null||node.children=='null'){
      //   delete node.children;
      // }
      return {
        id: node.value,
        label: node.label || this.orgName,
        // children: node.children&&node.children.length?node.children:'',
        // isDisabled: node.id==0 ? true : false || node.label=="终端用户" ? true : false
      }
    },
    /**
     * @Description 动态删除编辑里的电话
     * @Author      YOYO     -     2021-09-24
     * @param       {bumber} phone [电话]
     */
    handleClose(phone) {
      let i = this.editPhoneList.indexOf(phone)
      this.editPhoneList.splice(i, 1);

      this.plusButtonShow = this.editPhoneList.length < 3
      this.inputVisible = this.editPhoneList.length <= 0
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    // 固话  
    handleInputConfirm(key) {
      // console.log(key)
      let inputValue = this.inputValue;
      let firstNumber = inputValue[0]

      let numberTest = /^[0-9,-]+$/.test(inputValue)
      // console.log(numberTest)

      if (!inputValue) {
        this.$message({
          type: 'warning',
          message: '手机号不能为空！'
        })
      } else if (firstNumber == 1) { // 手机号校验
        let test = /^1(3|4|5|6|7|8|9)\d{9}$/.test(inputValue)
        if (inputValue.length != 11) {
          this.$message({ type: 'warning', message: '手机号位数为11位！' })
        } else if (!test) {
          this.$message({ type: 'warning', message: '手机号格式不正确！' })
        } else {
          this.editPhoneList.push(inputValue)
        }
      } else if (!numberTest) {
        this.$message({ type: 'warning', message: '号码格式不正确！' })
      } else {
        this.editPhoneList.push(inputValue)
      }

      // let fixedTelReg = /^\d{3}-\d{7,8}|\d{4}-\d{7,8}$/.test(inputValue)
      // else if (!fixedTelReg) {
      //     this.$message({ type: 'warning', message: '请填写正确号码！【如: 11位手机号或固话(区号-号码) 】', duration: 5000 })
      // }


      if (this.editPhoneList.length) {
        this[key].tel = this.editPhoneList.join(';')
      } else {
        this[key].tel = ''
      }

      this.inputVisible = false;
      this.inputValue = '';

      this.plusButtonShow = this.editPhoneList.length < 3
    },
    /**
     * @Description 切换组织机构
     * @Author      YOYO     -             2021-09-24
     */
    handleInputOrg({ label }) {
      // label 表示选择了“终端用户”
      this.isWxUser = (label != '终端用户')

      // 邮箱校验-是终端用户时校验不同
      this.rules.email = label == '终端用户' ? [] : this.temp

      // 用户登录名校验-是终端用户时校验不同
      let rules = [...this.loginNameRules]
      rules[1] = {
        pattern: /^[1][3|4|5|6|7|8|9][0-9]{9}$/,
        message: "格式错误，组织为'终端用户'时，用户登录名为11位手机号",
        trigger: "blur"
      }
      // this.rules.loginName = label == '终端用户' ? rules : this.loginNameRules

      if (label == '终端用户') {
        this.adduserForm.email = ''
        this.editForm.email = ''
      }
    },
  },
  mounted: function () {
    // this.queryTreeNode();
    this.queryAlcoInfo(1, this.pagination.pageSize);
  }
};
</script>

<style lang="scss">
.InstitutionManagementContainer {
  height: 100%;

  .mainContent {
    margin: 12px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;
    position: relative;
  }

  .contentShowArea {
    position: relative;
    height: 100%;

    .contentArea {
      width: 100%;
      height: 100%;
      background: #fff;
      padding: 20px;
      box-sizing: border-box;
      position: relative;
    }
  }

  .treeAside {
    position: absolute;
    width: 300px;
    height: 100%;
    padding: 20px;
    left: 0;
    top: 0;
    box-sizing: border-box;

    .treeTop {
      position: absolute;
      height: 40px;
      line-height: 40px;
      font-size: 0;
      font-weight: bold;
      top: 20px;
      z-index: 10;
      // left: 30px;
      padding-left: 10px;

      .treeTopTitle {
        // margin-right: 115px;
        // width: 500px;
        font-size: 18px;
        color: #333;
      }

      .el-button {
        margin-left: -24px;
      }

      .complete {
        margin-left: 10px;
      }
    }

    .treeBox {
      overflow: hidden;
      height: 100%;
      border: 1px solid #ebeef5;
      padding: 40px 0 10px;
      box-sizing: border-box;
    }

    .tree {
      height: 100%;
      overflow: auto;

      .el-tree-node__content {
        height: 40px;
      }

      .custom-tree-node {
        height: 40px;
        line-height: 40px;
        width: 100%;
        position: relative;

        .treeLabel {
          font-size: 14px;
          display: inline-block;
          width: 130px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .treeBtn {
          // float: right;
          position: absolute;
          top: 0px;
          right: 5px;
          background-color: #fff;

          .el-button {
            margin-left: 0;
          }
        }
      }
    }
  }

  .management {
    margin-left: 280px;
    height: 100%;

    // padding: 10px 0;
    &>div {
      border: 1px solid #ebeef5;
      padding: 10px 20px;
      box-sizing: border-box;

      .title {
        font-size: 18px;
        font-weight: bold;
        color: #333;
      }
    }

    .userManagement {
      height: 100%;
      position: relative;

      .umHandler {
        overflow: hidden;
        line-height: 40px;
        margin: 10px 0;

        .umHandlerLeft {
          float: left;

          .el-input {
            vertical-align: middle;
            width: 200px;
            margin-right: 10px;

            .el-input__inner {
              line-height: 36px;
              height: 36px;
            }
          }
          .primaryBtn {
            background: #2177E6;
            color: #fff;
            padding: 0 15px;
            height: 36px;
            line-height: 36px;
            border: none;
            font-size: 14px;
            border-radius: 4px;
            outline: none;
            cursor: pointer;
            margin-right: 10px;
          }
        }

        .add {
          float: right;
          height: 32px;
          line-height: 32px;
          margin-top: 5px;
          padding: 0 12px;
        }

        .addUserModel {
          .dialog-title {
            padding-left: 20px;
            font-weight: bold;
            font-size: 24px;
          }

          .addUserForm {
            .el-form-item {
              .select {
                float: left;
                width: 150px;
              }

              .checkBox {
                margin-left: 20px;
                height: 60px;
                line-height: 30px;
                float: left;

                .el-checkbox-group {
                  height: 24px;
                  line-height: 24px;
                }

                .el-checkbox {
                  height: 24px;
                  line-height: 24px;
                }
              }
            }
          }
        }
      }

      .umTableBox {
        margin-top: 20px;

        .tableBox {
          width: 100%;
          position: relative;
          min-height: 460px;

          .hasNoData {
            position: absolute;
            width: 360px;
            height: 392px;
            top: 55%;
            left: 50%;
            margin-top: -196px;
            margin-left: -180px;

            .noDataImg {
              width: 360px;
              height: 360px;

              img {
                width: 100%;
                height: 96%;
              }
            }

            p {
              text-align: center;
              margin-top: -10px;
              font-size: 24px;
              font-weight: bold;
              color: rgba(0, 73, 173, 1);
              line-height: 32px;
            }
          }
        }

        .dataTable {
          &::before {
            display: none;
          }

          // .el-table__header-wrapper {
          //   tr {
          //     background: #f8f8f8;

          //     th {
          //       background: #f8f8f8;
          //       border-bottom: 2px solid rgba(46, 91, 255, 0.5);
          //       color: #333333;
          //       padding: 10px 0;

          //       .cell {
          //         // font-weight: bold;
          //         font-family: PingFangBold;

          //         .caret-wrapper {
          //           height: 29px;

          //           .ascending {
          //             top: 3px;
          //           }

          //           .descending {
          //             bottom: 5px;
          //           }
          //         }
          //       }
          //     }
          //   }
          // }

          // .el-table__body-wrapper {
          //   tbody {
          //     tr {
          //       td {
          //         border: none;
          //         padding: 9px 0;

          //         .cell {
          //           color: #333;
          //         }
          //       }
          //     }
          //   }
          // }

          .el-table__fixed-right {
            &::before {
              display: none;
            }

            // .el-table__fixed-header-wrapper {
            //   tr {
            //     // background: #f8f8f8;

            //     th {
            //       background: #f8f8f8;
            //       border-bottom: 2px solid rgba(46, 91, 255, 0.5);
            //       color: #333333;
            //       padding: 10px 0;

            //       .cell {
            //         // font-weight: bold;
            //         font-family: PingFangBold;

            //         .caret-wrapper {
            //           height: 29px;

            //           .ascending {
            //             top: 3px;
            //           }

            //           .descending {
            //             bottom: 5px;
            //           }
            //         }
            //       }
            //     }
            //   }
            // }

            .el-table__fixed-body-wrapper {
              tbody {
                tr {
                  td {
                    // border: none;
                    // padding: 9px 0;

                    .cell {
                      text-align: center;

                      .editBtn {
                        color: #28c6a2;
                      }

                      .delBtn {
                        color: #dd3071;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.InstitutionManagementDD {
  .formBox {
    .el-form-item {
      .content-panel {
        line-height: 40px;

        &>.el-checkbox {
          line-height: 50px;
        }
      }

      .privilege-form-item {
        padding: 0 10px;
      }
    }

    .el-input-number {
      width: 270px;
    }
  }

  .formBox1 {
    .el-input {
      width: 100%;
    }

    .vue-treeselect {
      margin-top: 5px;

      .vue-treeselect__control {
        div {
          line-height: 40px;
          height: 40px;
        }
      }
    }
  }

  // .formBox {
  //   width: 650px;
  //   padding: 0 20px;
  //   height: 100%;
  //   overflow: auto;

  //   .el-form-item__content {
  //     margin-left: 0 !important;
  //     width: 100%;

  //     .el-input-number {
  //       width: 100%;
  //     }
  //   }

  //   .el-form {
  //     .el-form-item {
  //       margin-bottom: 16px;

  //       .el-select {
  //         width: 100%;

  //         .el-input__inner {
  //           height: 38px;
  //         }
  //       }

  //       .el-input {
  //         .el-input__inner {
  //           height: 38px;
  //         }
  //       }

  //       .treeSelect {
  //         .vue-treeselect__control {
  //           .vue-treeselect__value-container {
  //             font-size: 0;

  //             .vue-treeselect__placeholder {
  //               font-size: 14px;
  //             }
  //           }
  //         }
  //       }

  //       .el-input-number {
  //         .el-input-number__decrease {
  //           height: 36px;
  //         }

  //         .el-input-number__increase {
  //           height: 36px;
  //         }
  //       }
  //     }

  //     .belongTypeItem {
  //       .el-form-item__content {
  //         line-height: 36px;
  //       }
  //     }
  //   }
  // }
}

.drawerBody {

  // .el-tag + .el-tag {
  //   margin-left: 10px;
  // }
  .el-tag {
    margin-right: 10px;
  }

  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 180px !important;
    margin-right: 10px;
    vertical-align: bottom;
  }

  // .user-phones {
  //   width: 200px;
  //   position: relative;
  //   display: inline-block;
  //   margin-right: 10px;
  //   .el-input {
  //   }
  //   .minus-btn {
  //       position: absolute;
  //       top: 6px;
  //       right: 1px;
  //       padding: 11px;
  //       margin-left: 20px;
  //     }
  // }
  .plus-btn {
    padding: 8px;
    margin-left: 10px;
  }
}
.el-form{
  .belongTypeItem{
    .el-select{
      width: 270px;
    }
  }
}
.el-select-dropdown{
  &.is-multiple{
    .el-select-dropdown__item{
      padding: 0 !important;
      .el-tree{
        padding: 10px;
      }
      &.treeCommon{
        padding-left: 20px !important;
      }
    }
  }
}
</style>
